import { useEffect, useState } from 'react';

import { APP_COLOR_SCHEME, type ColorScheme } from './theme-provider';

/**
 * Throwaway scaffolding for design experimentation, not a pattern to copy or
 * build on. The dashboard ships one scheme with no user-facing theme control;
 * this exists only so the light values can be judged in context, and is meant
 * to be deleted along with this file. A real scheme control should be designed
 * as one rather than grown from here.
 */
const EXPERIMENT_HOSTS = ['localhost', '127.0.0.1', 'preview-kapa-ui.kapa.ai'];

export const useSchemeExperiment = (): ColorScheme => {
  const [scheme, setScheme] = useState<ColorScheme>(APP_COLOR_SCHEME);

  useEffect(() => {
    if (!EXPERIMENT_HOSTS.includes(window.location.hostname)) return;

    const onKeyDown = (event: KeyboardEvent) => {
      // `code` not `key` so the shortcut survives non-QWERTY layouts.
      if (event.code !== 'KeyL') return;
      if (!event.shiftKey || !(event.metaKey || event.ctrlKey)) return;

      event.preventDefault();
      setScheme((current) => (current === 'dark' ? 'light' : 'dark'));
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return scheme;
};
